define('global/UI/ClickMenuNav',[
	'jquery',
	'plugins/clickmenu'
], function ($, ClickMenu) {
	function init() {
		var $mainNav = $('.main-nav'), $cloneNav = $mainNav.clone(), $siteHeader = $('.siteHeader'), $toggleMenu = $('.siteHeader .header-links .toggle-menu');
		
		// clone the navigation and append it to the header.
		$cloneNav.addClass('cloned').appendTo($siteHeader);
		
		// Remove all elements except the first child of the navigation
		$cloneNav.find('ul.cm-menu > li:not(:first-child)').remove();
		
		// Remove toggle menu
		$cloneNav.find('.toggle-menu').remove();
		
		// Make clickmenu call on both.
		$(".main-nav").clickMenu({landings:true });
		
		var $mobileSubs = $(".header__new-wrap > .header__new-wrapInner > .main-nav.nav-bar > .cm-menu ul");
		$mobileSubs.each(function(){
			var $sub = $(this),
				$back = $("<a href='#' role='button' class='back'>Back to menu</a>");

			var $wrap = $sub.is(".custom-sub") ? $("<div class='back-wrap'></div>") : $("<li class='back-wrap'></li>");
			
			if ( $sub.parents(".custom-sub").length <= 0 ) {
				$wrap.append($back);
				$sub.prepend($wrap);
				$back.on("click", function(e){
					e.preventDefault();
					$sub.siblings(".has-sub").trigger("click");
				});
			}
		});


		$toggleMenu.on('click', function (e) {
			e.preventDefault();			
			$('html').toggleClass('cm-js-menu-active');
			$toggleMenu.toggleClass('active');
            $siteHeader.toggleClass('fixed-pos');
		});
	}
	
	// Initialize Main Navigation
	init();
	
	var Navigation = {init: init};
	
	return Navigation
});
